import I18n from 'I18n';
//Time value for UITimePicker for 11:59PM
export const ONE_MINUTE_BEFORE_MIDNIGHT = 24 * 60 - 1;
export const getTimeValueFromMoment = value => {
  const momentHours = value.hour();
  const momentMinutes = value.minute();
  return momentHours * 60 + momentMinutes;
};
export const getCurrentTimeValue = inUTC => {
  const currentTimeValue = getTimeValueFromMoment(inUTC ? I18n.moment.utc() : I18n.moment());
  return Math.round(currentTimeValue / 30) * 30;
};
export const getNewTimeValue = (value, time) => {
  if (!value) {
    return null;
  }
  if (time === ONE_MINUTE_BEFORE_MIDNIGHT) {
    return value.hours(23).minutes(59).seconds(59).milliseconds(999);
  }
  const hoursValue = time / 60;
  const minutesValue = time % 60;
  return value.hours(hoursValue).minutes(minutesValue).seconds(0).milliseconds(0);
};